/* Printies — mini minimum gate. Individual minis (product_type "Flexi Friend")
   are $3.49 each with a 5-mini minimum, mix & match — but ONLY when the cart
   is minis-only. Any bundle/Random Pack/Clicker in the cart lifts the gate
   (a $3.49 add-on to a $34.99 box is fine; a lone $3.49 checkout is not).
   While gated, checkout buttons are disabled with a friendly note.
   Theme-level enforcement: a visitor hitting /checkout directly can bypass
   it — accepted trade-off vs building a checkout-validation app. */
(function () {
  "use strict";
  var MIN = 5;
  var TYPE = "Flexi Friend";
  var state = { minis: 0, others: 0 };

  function checkoutEls() {
    return document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], .cart__checkout-button, #CartDrawer-Checkout'
    );
  }

  function apply() {
    var els = checkoutEls();
    if (!els.length) return;
    var need = MIN - state.minis;
    var blocked = state.minis > 0 && need > 0 && state.others === 0;
    Array.prototype.forEach.call(els, function (b) {
      if (blocked) {
        b.disabled = true;
        b.setAttribute("data-pt-minblock", "1");
      } else if (b.getAttribute("data-pt-minblock")) {
        b.disabled = false;
        b.removeAttribute("data-pt-minblock");
      }
      var note = b.parentNode.querySelector(".pt-minnote");
      if (blocked) {
        if (!note) {
          note = document.createElement("div");
          note.className = "pt-minnote";
          note.style.cssText =
            "margin:8px 0;padding:10px 12px;border-radius:10px;background:#fff3f8;" +
            "color:#20384d;font-size:1.3rem;line-height:1.35;text-align:left;";
          b.parentNode.insertBefore(note, b);
        }
        note.innerHTML =
          "🧺 <strong>Minis come in packs!</strong> Add " + need + " more mini" +
          (need === 1 ? "" : "s") + " to check out (mix &amp; match any figures) — or " +
          '<a href="/pages/build-a-box">build a box</a> and save.';
      } else if (note) {
        note.remove();
      }
    });
  }

  function refresh() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = 0, o = 0;
        (c.items || []).forEach(function (it) {
          if (it.product_type === TYPE) n += it.quantity;
          else o += it.quantity;
        });
        state.minis = n;
        state.others = o;
        apply();
      })
      .catch(function () {});
  }

  // re-count after any cart mutation (theme uses fetch for add/change/update)
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (typeof url === "string" && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 300); });
    }
    return p;
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refresh);
  } else {
    refresh();
  }
  setInterval(apply, 1200);    // drawer re-renders replace the button nodes
  setInterval(refresh, 20000); // slow safety resync
})();
